import { render, staticRenderFns } from "./home-counters.vue?vue&type=template&id=68e3f01c"
import script from "./home-counters.vue?vue&type=script&lang=js"
export * from "./home-counters.vue?vue&type=script&lang=js"
import style0 from "./home-counters.vue?vue&type=style&index=0&id=68e3f01c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports